import React from 'react'
import { 
  Snackbar
} from '@mui/material'
import { 
  EditModal, 
  ConfirmDialog, 
  MetricsList,
  QuickTemplates,
  TestMetricModal
} from './components'
import { useCustomScores } from './hooks'
import { Typography } from '../../interfaces/typography'
import { CustomScoresView } from '../../lib/redux/custom-scores/slice'

export function CustomScores() {
  const {
    // State
    definitions,
    loading,
    currentView,
    editingDefinition,
    testingMetric,
    showConfirmDialog,
    metricChanges,
    templateTab,
    hasUnsavedChanges,
    error,
    snackbarOpen,
    codeOptions,

    // Setters
    setDefinitions,

    // Redux actions
    openEditModal,
    closeEditModal,
    openTestModal,
    closeTestModal,
    setTemplateTab,
    clearError,
    setSnackbarOpen,

    // Actions
    handleSave,
    confirmSave,
    addNewDefinition,
    handleDelete,
    handleEditSave,
    handleUndoChanges,
    handleCloseConfirmDialog,
    handleTestFromEdit,
    handleEditFromTest
  } = useCustomScores()

  if (loading) {
    return (
      <div className="flex items-center justify-center py-12">
        <Typography variant="mediumParagraph" color="#6B7280">Loading custom scores...</Typography>
      </div>
    )
  }

  return (
    <>
      <div className="h-full p-6">
        {/* Content area */}
        <div className="grid grid-cols-[2fr_1fr] gap-8 h-full">
          <MetricsList
              definitions={definitions}
            hasChanges={hasUnsavedChanges}
            addNewDefinition={() => addNewDefinition()}
            setEditingDef={openEditModal}
              handleDelete={handleDelete}
            handleSave={handleSave}
            handleUndoChanges={handleUndoChanges}
            onTestMetric={openTestModal}
          />

          <QuickTemplates
            templateTab={templateTab}
            setTemplateTab={setTemplateTab}
            addNewDefinition={addNewDefinition}
          />
        </div>
      </div>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={5000}
        onClose={() => setSnackbarOpen(false)}
        message={error || ''}
      />

      {currentView === CustomScoresView.EDITING && editingDefinition && (
        <EditModal
          open={true}
          definition={editingDefinition}
          definitions={definitions}
          codeOptions={codeOptions}
          onClose={closeEditModal}
          onSave={handleEditSave}
          onTest={handleTestFromEdit}
        />
      )}

      {currentView === CustomScoresView.TESTING && testingMetric && (
        <TestMetricModal
          open={true}
          metric={testingMetric}
          onClose={closeTestModal}
          onEdit={handleEditFromTest}
        />
      )}

      <ConfirmDialog
        open={showConfirmDialog}
        changes={metricChanges}
        onClose={handleCloseConfirmDialog}
        onConfirm={confirmSave}
      />
    </>
  )
}